export const SET_MARKETING_FILES = 'SET_MARKETING_FILES';
export const LOAD_MARKETING_FILES = 'LOAD_MARKETING_FILES';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const SET_SALES_MATERIAL_FILTER = 'SET_SALES_MATERIAL_FILTER';

export const downloadFile = (url, fileName) => ({
  type: DOWNLOAD_FILE,
  url,
  fileName
});

export const loadMarketingFiles = () => ({
  type: LOAD_MARKETING_FILES
});

export const setMarketingFiles = payload => ({
  type: SET_MARKETING_FILES,
  payload
});

export const setSalesMaterialFilter = salesMaterialCategory => ({
  type: SET_SALES_MATERIAL_FILTER,
  salesMaterialCategory
});

const initialState = {
  loading: true,
  marketingFiles: [],
  customMarketingFiles: [],
  salesMaterialFilter: null
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MARKETING_FILES:
      return {
        ...state,
        marketingFiles: action.payload.marketing_files,
        customMarketingFiles: action.payload.custom_marketing_files,
        loading: false
      };
    case SET_SALES_MATERIAL_FILTER:
      return {
        ...state,
        salesMaterialFilter: action.salesMaterialCategory
      };
    default:
      return state;
  }
};
